import { projectFilesMutations } from './files';
import { issueMutations } from './issues';
import { projectPDFMutations } from './pdf';
import { projectCountryMutations } from './projectCountry';
import { projectDateMutations } from './projectDate';
import { projectRepriceMutations } from './projectReprice';
import { projectTagMutations } from './projectTags';
import { projectTeamMutations } from './projectTeam';
import { projectEntityMutations } from './projects';
import { recruitmentMutations } from './recruitment';
import { projectSampleMutations } from './sample';
import { projectServiceMutations } from './services';
import { subTaskMutations } from './subTasks';
import { taskMutations } from './task';
import { taskCommentMutations } from './taskComments';
import { taskExcludedIdsMutations } from './taskExcludedIds';
import { taskFileMutations } from './taskFile';
import { taskSampleProjectMutations } from './taskSampleProject';
import { taskTagsMutations } from './taskTags';

export const projectMutations = {
  ...projectPDFMutations,

  ...projectEntityMutations,

  ...projectRepriceMutations,
  ...projectTagMutations,
  ...projectCountryMutations,
  ...projectDateMutations,
  ...projectServiceMutations,

  ...recruitmentMutations,

  ...projectFilesMutations,
  ...projectSampleMutations,

  ...taskExcludedIdsMutations,
  ...taskSampleProjectMutations,
  ...taskMutations,
  ...taskCommentMutations,
  ...subTaskMutations,
  ...taskTagsMutations,
  ...taskFileMutations,

  ...issueMutations,

  ...projectTeamMutations,
};
